(function (e, t) {
  if (e) {
    var a = function () {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", a, !0);
    };
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? a()
        : e.addEventListener("lazyunveilread", a, !0);
  }
})("undefined" != typeof window ? window : 0, function (e, t, a) {
  "use strict";
  function r(a, r) {
    var i = "callback" + f,
      n = t.createElement("script");
    (a = new URL(a)),
      a.searchParams.append("callback", i),
      f++,
      (e[i] = function (t) {
        n.parentNode.removeChild(n), delete e[i], r(t);
      }),
      (n.src = a),
      t.head.appendChild(n);
  }
  function i(e, t) {
    const a = t.getAttribute("data-thumbnail");
    a
      ? (t.style.backgroundImage = "url(" + a + ")")
      : r(L + encodeURIComponent(A.replace(b, e)), function (e) {
          e = JSON.parse(e.contents);
          e && e.thumbnail_url
            ? (t.style.backgroundImage = "url(" + e.thumbnail_url + ")")
            : e &&
              e.url &&
              (t.style.backgroundImage = "url(" + e.url + "?width=640)");
        }),
      t.addEventListener("click", n);
  }
  function n(e) {
    var t = e.currentTarget,
      a = t.getAttribute("data-rutube"),
      r = t.getAttribute("data-rutubeparams") || "";
    t.removeEventListener("click", n),
      a,
        e.preventDefault(),
        (t.innerHTML =
          '<iframe src="' + a +
          '" frameborder="0" allowfullscreen="" width="640" height="390" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>');
  }
  function u(e) {
    const t = e.getAttribute("data-thumbnail");
    (e.style.backgroundImage = "url(" + t + ")"),
      e.addEventListener("click", l);
  }
  function kinescopeStart(e) {
    const t = e.getAttribute("data-thumbnail");
    (e.style.backgroundImage = "url(" + t + ")"),
      e.addEventListener("click", kinescope);
  }
  function l(e) {
    var t = e.currentTarget,
      a = t.getAttribute("data-vkvideo"),
      r = a.match(/video([^&\?_]+)_([^&\?_]+)/),
      i = r[1],
      n = r[2];

    t.removeEventListener("click", l),
      n &&
        (e.preventDefault(),
        (t.innerHTML =
          '<iframe src="' + a +
          '&autoplay=1" frameborder="0" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" allowfullscreen="" width="640" height="390"></iframe>'));
  }
  function kinescope(e) {
    var t = e.currentTarget,
      a = t.getAttribute("data-kinescope");

    t.removeEventListener("click", l),
      a &&
        (e.preventDefault(),
        (t.innerHTML =
          '<iframe src="' + a +
          '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" allowfullscreen="" width="640" height="390"></iframe>'));
  }
  function o(e, t) {
    r(k.replace(b, e), function (e) {
      e &&
        e.thumbnail_url &&
        (t.style.backgroundImage = "url(" + e.thumbnail_url + ")");
    }),
      t.addEventListener("click", d);
  }
  function d(e) {
    var t = e.currentTarget,
      a = t.getAttribute("data-vimeo"),
      r = t.getAttribute("data-vimeoparams") || "";
    t.removeEventListener("click", d),
      a &&
        g.test(a) &&
        (!r || g.test(r)) &&
        (r && !p.test(r) && (r = "&" + r),
        e.preventDefault(),
        (t.innerHTML =
          '<iframe src="' +
          w.replace(b, a) +
          r +
          '" frameborder="0" allowfullscreen="" width="640" height="390"></iframe>'));
  }
  function c(e, t) {
    var r = t.getAttribute("data-thumb-size") || a.cfg.ytThumb || "hqdefault";
    (t.style.backgroundImage = "url(" + h.replace(b, e).replace(v, r) + ")"),
      t.addEventListener("click", s);
  }
  function s(e) {
    var t = e.currentTarget,
      a = t.getAttribute("data-youtube"),
      r = t.getAttribute("data-ytparams") || "";
    t.removeEventListener("click", s),
      a &&
        g.test(a) &&
        (!r || g.test(r)) &&
        (r && !p.test(r) && (r = "&" + r),
        e.preventDefault(),
        (t.innerHTML =
          '<iframe src="' +
          y.replace(b, a) +
          r +
          '" frameborder="0" allowfullscreen="" width="640" height="390"></iframe>'));
  }
  if (!t.getElementsByClassName) return;
  var m = "https:" == location.protocol ? "https:" : "http:",
    f = Date.now(),
    b = /\{\{id}}/,
    v = /\{\{hqdefault}}/,
    p = /^&/,
    g = /^[a-z0-9-_&=]+$/i,
    h = m + "//img.youtube.com/vi/{{id}}/{{hqdefault}}.jpg",
    y = m + "//www.youtube.com/embed/{{id}}?autoplay=1",
    k = m + "//vimeo.com/api/oembed.json?url=https%3A//vimeo.com/{{id}}",
    w = m + "//player.vimeo.com/video/{{id}}?autoplay=1";
  const L = "https://api.allorigins.win/get?url=";
  var A = "https://rutube.ru/api/video/{{id}}/thumbnail/",
    z = "https://rutube.ru/play/embed/{{id}}/",
    E = /\{\{oid}}/,
    _ = "https://vk.com/video_ext.php?oid={{oid}}&id={{id}}&js_api=0";
  t.addEventListener("lazybeforeunveil", function (e) {
    if (e.detail.instance == a) {
      var t = e.target,
        r = t.getAttribute("data-youtube"),
        n = t.getAttribute("data-vimeo"),
        l = t.getAttribute("data-rutube"),
        d = t.getAttribute("data-vkvideo"),   
        k = t.getAttribute("data-kinescope");        
        
      r && t && c(r, t), n && t && o(n, t), l && t && i(l, t), d && t && u(t), k && t && kinescopeStart(t);
    }
  });
});
